/**
 * EDIT ESTABLISHMENT
 */
import { t } from "i18next"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { useState } from "react"
import establishmentStore from "../model/establishment.store"
import EstablishmentCard from "./EstablishmentCard"
import EstablishmentFormModal from "./modal/EstablishmentFormModal"
import { toast } from "react-toastify"
import PageHeader from "@/components/page-header"
import Card from "@/components/card"
import EstablishmentContributors from "./EstablishmentContributors"

export default function EstablishmentConfig() {
  const dispatch = useAppDispatch()

  const establishment = useAppSelector(establishmentStore.selectors.active)
  const status = useAppSelector(establishmentStore.selectors.status)
  const [modal, setModal] = useState<"MODAL_EDIT" | null>(null)

  const handleSave = async () => {
    if (!establishment.name) {
      toast(t("Le nom de l'établissement ne peut pas être vide"))
      return
    } else {
      const establishment = await dispatch(establishmentStore.thunks.updateEntity()).unwrap()
      dispatch(establishmentStore.actions.replace(establishment))
      setModal(null)
    }
  }

  return (
    <>
      <PageHeader
        title="Établissement"
        subtitle="Modifiez les informations propres à l'établissement et nommez les contributeurs au document unique."
      />

      {modal === "MODAL_EDIT" && (
        <EstablishmentFormModal status={status} onSave={handleSave} onClose={() => setModal(null)} />
      )}

      <EstablishmentCard establishment={establishment} onEdit={() => setModal("MODAL_EDIT")} />

      <Card>
        <EstablishmentContributors establishment={establishment} />
      </Card>
    </>
  )
}
